import React, { useCallback, useEffect, useRef, useState } from "react"
import {
  IInformation,
  IMediaAsset,
} from "packages/gatsby-theme-strapi/gatsby-graphql"
import { Heading } from "../../ui"
import {
  ContentWrapper,
  Description,
  ItemContent,
  ItemDescription,
  ItemHeading,
  ItemHeadingIcon,
  ItemWrapper,
  Items,
  SectionWrapper,
  ToggleBoxWrapper,
} from "./toggle-box-elements"
import { SectionProps } from "../section-loader"

interface ToggleBoxProps extends SectionProps {
  data: {
    heading?: string
    description?: string
    items?: IInformation[]
    image?: IMediaAsset
  }
}

const ToggleBox = ({ data }: ToggleBoxProps) => {
  const [opened, setOpened] = useState<number | null>(null)
  const itemsRefs = useRef<(HTMLDivElement | null)[]>([])

  return (
    <SectionWrapper>
      <ContentWrapper>
        <Heading.H2>{data.heading}</Heading.H2>
        {data.description && <Description>{data.description}</Description>}
        <ToggleBoxWrapper>
          {
            data.image && <img src={data.image?.url as string} /> // TODO: GatsbyImage
          }
          <Items>
            {data.items &&
              data.items.length > 0 &&
              data.items.map((item, idx) => (
                <ItemWrapper key={idx}>
                  <ItemHeading
                    onClick={() => setOpened(opened !== idx ? idx : null)}
                  >
                    <Heading.H5>{item.heading}</Heading.H5>
                    <ItemHeadingIcon>
                      {opened === idx ? "-" : "+"}
                    </ItemHeadingIcon>
                  </ItemHeading>
                  <ItemContent
                    ref={i => itemsRefs.current.push(i)}
                    opened={opened === idx}
                    height={itemsRefs.current[idx]?.scrollHeight}
                  >
                    <ItemDescription>{item.description}</ItemDescription>
                  </ItemContent>
                </ItemWrapper>
              ))}
          </Items>
        </ToggleBoxWrapper>
      </ContentWrapper>
    </SectionWrapper>
  )
}

export default ToggleBox
